import { withStyles } from '@material-ui/core/styles';
import _get from 'lodash/get';
import _has from 'lodash/has';
import Parser from 'html-react-parser';
import _isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import { INLINES, BLOCKS } from '@contentful/rich-text-types';
import { documentToHtmlString } from '@contentful/rich-text-html-renderer';
import React from 'react';
import Colors from 'utils/colors';

const styles = () => ({
  intro: {
    width: '60%',
    color: 'white',
    textAlign: 'center',
    fontSize: 14,
    '& > p > a': {
      color: Colors.link,
      textDecoration: 'none',
      fontFamily: 'MadaMedium',
    },
  },
});

const TITLE_TYPES = ['book', 'events', 'podcast', 'topics', 'video'];

export const AssessmentRichTextParser = data => {
  const options = {
    renderNode: {
      [INLINES.EMBEDDED_ENTRY]: node => {
        const linkMapping = {
          person: 'people',
          book: 'books',
          application: 'apps',
          podcast: 'podcasts',
          activity: 'articles',
          video: 'videos',
          organization: 'organizations',
          topics: 'topics',
          reads: 'articles',
          events: 'events',
        };
        const reviewStatus = _get(node, [
          'data',
          'target',
          'fields',
          'reviewStatus',
        ]);
        const isStatusAccepted = reviewStatus === 'Accepted';
        const link = isStatusAccepted
          ? `/${linkMapping[node.data.target.sys.contentType.sys.id]}/${_get(
              node,
              'data.target.fields.slug',
            )}`
          : '#';
        const hasContentTypes = !_isEmpty(
          _get(node, 'data.target.sys.contentType'),
        );
        const typeContent =
          hasContentTypes && node.data.target.sys.contentType.sys.id;
        const finalType = TITLE_TYPES.includes(typeContent) ? 'title' : 'name'; // check what field to use, title or name
        // add the search brand when present
        if (!_has(node.data.target.fields, finalType)) return null;
        const linkClass = isStatusAccepted
          ? 'embedded-link'
          : 'embedded-link-inactive';
        return `<a href="${link}" class="${linkClass}">
        ${node.data.target.fields[finalType]}</a>`;
      },
      [INLINES.ENTRY_HYPERLINK]: node => {
        const linkMapping = {
          person: 'people',
          book: 'books',
          application: 'apps',
          podcast: 'podcasts',
          activity: 'articles',
          video: 'videos',
          organization: 'organizations',
          topics: 'topics',
          reads: 'articles',
          events: 'events',
        };
        const reviewStatus = _get(node, [
          'data',
          'target',
          'fields',
          'reviewStatus',
        ]);
        const isStatusAccepted = reviewStatus === 'Accepted';
        const link = isStatusAccepted
          ? `/${linkMapping[node.data.target.sys.contentType.sys.id]}/${_get(
              node,
              'data.target.fields.slug',
            )}`
          : '#';
        const hasContentTypes = !_isEmpty(
          _get(node, 'data.target.sys.contentType'),
        );
        const typeContent =
          hasContentTypes && node.data.target.sys.contentType.sys.id;
        const finalType = TITLE_TYPES.includes(typeContent) ? 'title' : 'name'; // check what field to use, title or name
        // add the search brand when present
        if (!_has(node.data.target.fields, finalType)) return null;
        const linkClass = isStatusAccepted
          ? 'embedded-link'
          : 'embedded-link-inactive';
        return `<a href="${link}" class="${linkClass}">
        ${node.data.target.fields[finalType]}</a>`;
      },
      [BLOCKS.PARAGRAPH]: (node, next) => {
        const nodeHasValue = !_isEmpty(next(node.content));
        const content = `<p>${next(node.content).replace(
          /(?:\r\n|\r|\n)/g,
          '',
        )}</p>`;
        return nodeHasValue ? `${content}` : null;
      },
      [INLINES.HYPERLINK]: (node, next) => {
        const splittedUrl = node.data.uri.split(' ');
        return `<a href="${splittedUrl[0]}" ${splittedUrl[1]}>${next(
          node.content,
        )}</a>`;
      },
    },
  };
  const parsedData = documentToHtmlString(data, options);

  return Parser(parsedData);
};

const RichTextIntro = ({ classes, data }) => {
  if (_isEmpty(data)) return null;

  return <div className={classes.intro}>{AssessmentRichTextParser(data)}</div>;
};

RichTextIntro.propTypes = {
  data: PropTypes.object,
  classes: PropTypes.object,
};

export default withStyles(styles)(RichTextIntro);
